import React, { ReactNode } from "react"
import "./ActDropdown.css"

interface Props {
    icon: ReactNode | string
    label: ReactNode | string
    children: ReactNode
}

interface State {
    open: boolean
}

/**
 * This is emulating the ACT Digital Practice Test dropdown, specifically designed for that usage!
 */
class ActDropdown extends React.Component<Props, State> {
    dropdownRef: React.RefObject<HTMLDivElement>

    constructor(props: Props) {
        super(props)
        this.state = { open: false }
        this.dropdownRef = React.createRef()
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside)
    }

    handleClickOutside = (e: MouseEvent) => {
        if (
            this.dropdownRef.current &&
            !this.dropdownRef.current.contains(e.target as Node)
        ) {
            this.setState({ open: false })
        }
    }

    toggle = () => {
        this.setState(prev => ({ open: !prev.open }))
    }

    close = () => {
        this.setState({ open: false })
    }

    render() {
        let { label, icon, children } = this.props
        let { open } = this.state

        return (
             <div className="act-dropdown" ref={this.dropdownRef}>
                <button aria-label={`Toggle the ${label} menu`} className="act-dropdown-button" onClick={this.toggle}>
                    <span className="act-dropdown-label">
                        <span className="act-dropdown-icon">
                            {icon}
                        </span>
                        <span className="d-none d-lg-inline">{label}</span>
                    </span>
                    <span className="act-dropdown-caret">▾</span>
                </button>

                {open && (
                    <div className="act-dropdown-menu" onClick={this.close}>
                        {children}
                    </div>
                )}
            </div>
        )
    }
}

export default ActDropdown



interface FilterProps {
    label: string
    children: ReactNode
}
export class ActFilterDropdown extends React.Component<FilterProps, State> {
    dropdownRef: React.RefObject<HTMLDivElement>

    constructor(props: FilterProps) {
        super(props)
        this.state = { open: false }
        this.dropdownRef = React.createRef()
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside)
    }

    handleClickOutside = (e: MouseEvent) => {
        if (
            this.dropdownRef.current &&
            !this.dropdownRef.current.contains(e.target as Node)
        ) {
            this.setState({ open: false })
        }
    }

    toggle = () => {
        this.setState(prev => ({ open: !prev.open }))
    }

    close = () => {
        this.setState({ open: false })
    }

    render() {
        let { label, children } = this.props
        let { open } = this.state

        return (
             <div className="act-filter-dropdown" ref={this.dropdownRef}>
                <button className="act-filter-dropdown-button" onClick={this.toggle}>
                    <span className="act-filter-dropdown-label">{label}</span>
                    <span className="filter">▾</span>
                </button>

                {open && (
                    <div className="act-filter-dropdown-menu" onClick={this.close}>
                        {children}
                    </div>
                )}
            </div>
        )
    }
}
